module.exports = __webpack_public_path__ + "img/opn.4ad60f41.svg";